import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import 'common/treeModule';
import './shopsServices';
import './shopsDirectives';

/* jshint -W106, -W003 */  // Disable warnings for non-camelCase identifiers and using before defined

// ES modules are strict by default
const shopControllers = angular.module('applicationModule.shopsControllers', [
    'ngSanitize',
    'applicationModule.shopsDirectives',
    'applicationModule.shopsServices',
    'commonModule.treeModule',
    'ngFileUpload',
    'ui.bootstrap',
    'ui.select'
]);

// Helper function for integer validation
function isInt(number) {
    'use strict';
    //number = parseInt(number);
    if (number >= 0) {
        return number % 1 === 0;
    } else {
        return false;
    }
}

shopControllers.controller('ShopsController', ['$scope', '$state', '$rootScope', '$stateParams', 'NgTableParams', 'Shop', 'AppsoupAPI', 'Permissions', 'growl', function ($scope, $state, $rootScope, $stateParams, NgTableParams, Shop, AppsoupAPI, Permissions, growl) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('shops');
    $scope.application_id = $stateParams.application_id;
    $scope.package_id = null;
    $scope.search = {};
    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };
    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Shop.getList($scope.application_id, params._params)
                .then(function (response) {
                    const shop = response.shop;
                    params.total(shop.total);
                    params.count(shop.per_page);
                    params.page(shop.current_page);

                    $scope.package_id = response.packageId;

                    return shop.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });
    $scope.removeProduct = function (id, index) {
        Shop.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.SHOP.DELETE_SHOP');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.SHOP.ERROR_DELETE');
                }
            });
    };
    $scope.newShop = function () {
        $state.go('appsoup.application.shopNew');
    };

    $scope.searchShops = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.title)) {
            $scope.tableParams._params.title = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.street)) {
            $scope.tableParams._params.street = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.city)) {
            $scope.tableParams._params.city = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.post_code)) {
            $scope.tableParams._params.post_code = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

}]);

shopControllers.controller('ShopController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'Shop', 'AppsoupAPI', 'Permissions', 'growl', '$filter', function ($scope, $rootScope, $state, $stateParams, NgTableParams, Shop, AppsoupAPI, Permissions, growl, $filter) {
    'use strict';
    $scope.writeAccess = Permissions.hasWriteAccess('shops');
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.shop = {
        status: 1
    };
    $scope.types = [];
    $scope.editMode = false;

    const shopId = $stateParams.shopId;
    const appId = $stateParams.application_id;

    Shop.create(appId).then(function (result) {
        let data = result.data;

        if (data.success) {
            $scope.news_types = data.news_types;
            $scope.statuses = data.statuses;
            $scope.graphics = data.graphics;
            $scope.package_id = data.package_id;
        }
    });

    $scope.week = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];

    $scope.showElement = function (value) {
        return (angular.isDefined(value) && value);
    };

    if (angular.isDefined(shopId)) {
        $scope.editMode = true;
        Shop.get(shopId, $stateParams.application_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.shop = data.shop;
                $scope.shop.latitude = parseFloat($scope.shop.latitude);
                $scope.shop.longitude = parseFloat($scope.shop.longitude);
                $scope.shop.status = ($scope.shop.status) ? 1 : 0;

                angular.forEach($scope.shop.contact_info, function (value, key) {
                    $scope.shop[key] = value;
                });

                angular.forEach($scope.shop.opening_hours, function (value, key) {
                    if (value === 'close') {
                        $scope.shop[key] = '';
                        $scope.shop['checks_' + key] = true;
                    } else {
                        $scope.shop[key] = value;
                    }
                });

                delete $scope.shop.contact_info;
                delete $scope.shop.opening_hours;
            } else {
                $scope.formErrors = data.errors;
            }
        }).catch(function () {
            $state.go('appsoup.application.shops', {application_id: $stateParams.application_id}, growl.error('MODULES.SHOP.ERRORS.NO_DATA'));
        }).finally(function () {
            $scope.isLoading = false;
        });
    }
    $scope.searchTypes = function (text) {
        text = $filter('removeSpecial')(text);

        Shop.search(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.types = data.types;
            } else {
                growl.error(data.error);
            }
        });
    };
    $scope.changeTypes = function () {
        if (angular.isDefined($scope.shop.types)) {
            const tempTypes = [];
            angular.forEach($scope.shop.types, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTypes.indexOf(value) === -1) {
                    tempTypes.push(value);
                }
            });
            $scope.shop.types = tempTypes;
        }
    };
    $scope.saveShop = function () {
        $scope.shop.app_id = $stateParams.application_id;

        Shop.save($scope.shop, $scope.editMode).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.SHOP.SUCCESS_' + ($scope.editMode ? 'EDIT' : 'ADD'));
                $state.go('appsoup.application.shops');
            } else {
                if (typeof data.error === 'object') {
                    $scope.formErrors = data.error;
                } else {
                    if (data.error === 'MODULES.SHOP.ERRORS.HOURS') {
                        growl.error(data.error);
                    } else {
                        growl.error('MODULES.SHOP.ERRORS.SHOP');
                    }
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.hoursValidation = function (field, check) {
        let temp = [];
        if (field && (field !== '') && (check !== true)) {
            let h1 = [];
            let h2 = [];
            temp = field.split('-');
            if (angular.isDefined(temp[0]) && angular.isDefined(temp[1])) {
                h1 = temp[0].split(':');
                h2 = temp[1].split(':');

                if (isInt(h1[0]) && isInt(h1[1]) && isInt(h2[0]) && isInt(h2[1]) && (h1[0].toString().length === 2) && (h1[1].toString().length === 2) && (h2[0].toString().length === 2) && (h2[1].toString().length === 2)) {
                    h1[0] = parseInt(h1[0]);
                    h1[1] = parseInt(h1[1]);
                    h2[0] = parseInt(h2[0]);
                    h2[1] = parseInt(h2[1]);
                    if ((h1[0] > 23) || (h1[1] > 59) || (h2[0] > 23) || (h2[1] > 59) || ((h1[0] === h2[0]) && (h1[1] > h2[1])) || ((h1[0] === h2[0]) && (h1[1] === h2[1]))) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }

        return false;
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.shops');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'MODULES.SHOP.ERRORS.REQUIRED'}],
        'street': [{type: '$invalid', msg: 'MODULES.SHOP.ERRORS.REQUIRED'}],
        'street_number': [{type: '$invalid', msg: 'MODULES.SHOP.ERRORS.REQUIRED'}],
        'post_code': [{error: 'pattern', msg: 'MODULES.SHOP.ERRORS.POST_CODE'}, {
            error: 'required',
            msg: 'MODULES.SHOP.ERRORS.REQUIRED'
        }],
        'city': [{type: '$invalid', msg: 'MODULES.SHOP.ERRORS.REQUIRED'}],
        'country': [{type: '$invalid', msg: 'MODULES.SHOP.ERRORS.REQUIRED'}],
        'province': [{type: '$invalid', msg: 'MODULES.SHOP.ERRORS.REQUIRED'}],
        'latitude': [
            {error: 'required', msg: 'MODULES.SHOP.ERRORS.REQUIRED'},
            {error: 'max', msg: 'MODULES.SHOP.ERRORS.LAT'},
            {error: 'min', msg: 'MODULES.SHOP.ERRORS.LAT'}
        ],
        'longitude': [
            {error: 'required', msg: 'MODULES.SHOP.ERRORS.REQUIRED'},
            {error: 'max', msg: 'MODULES.SHOP.ERRORS.LON'},
            {error: 'min', msg: 'MODULES.SHOP.ERRORS.LON'}
        ],
        'fax': [
            {error: 'pattern', msg: 'MODULES.SHOP.ERRORS.FAX'},
            {error: 'maxlength', msg: 'MODULES.SHOP.ERRORS.FAXMAX'},
            {error: 'minlength', msg: 'MODULES.SHOP.ERRORS.FAXMIN'}
        ]
    };
}]);

export default shopControllers;
